import zaludGeneral from './general/flow';
import noseSinuses from './noseSinuses/flow';
import throatPain from './throatPain/flow';
import coldFlu from './coldFlu/flow';
import pinkEye from './pinkEye/flow';
import earInfection from './earInfection/flow';
import zaludStiIntake from './STI Intake/flow';
import zaludUtiTreatment from './utiTreatment/flow';
import yeastInfection from './yeastInfection/flow';

const ZaludFlows = {
  zaludGeneral,
  noseSinuses,
  throatPain,
  coldFlu,
  pinkEye,
  earInfection,
  zaludStiIntake,
  zaludUtiTreatment,
  yeastInfection
};

export default ZaludFlows;
